module.exports = __webpack_public_path__ + "img/6S.f0d7ffc5.png";